import Plyr from 'plyr';

export default class Videos {
    constructor() {
        this.init();
    }

    init() {
        const player = new Plyr('#introduction-player', {
            autoplay: true,
            controls:
                [
                    'play-large',
                    'progress',
                ],

            fullscreen: {enabled: false, fallback: true, iosNative: false, container: null}
        });

        player.on('controlsshown', event => {
            $('#introduction-skip-button-container').addClass('show');
        });

        player.on('controlshidden', event => {
            $('#introduction-skip-button-container').removeClass('show');
        });


        const playerEvent = new Plyr('.event-player', {
            controls:
                [
                    'play-large',
                    'progress',
                    // 'volume'
                ],
            // autoplay: true,
            // muted: true
        });
    }
}
